import React, { useState, useEffect } from 'react';
import { Modal, Box, TextField, Button } from '@mui/material';
import Swal from 'sweetalert2';
import api from '../services/api';

const PixKeyModal = ({ open, onClose, onSave, pixKey, fetchData }) => {
  const [formData, setFormData] = useState({
    nome: '',
    chavepix: '',
    valor: '',
    cidade: ''
  });

  useEffect(() => {
    if (pixKey) {
      setFormData({
        nome: pixKey.nome || '',
        chavepix: pixKey.chavepix || '',
        valor: pixKey.valor || '',
        cidade: pixKey.cidade || ''
      });
    } else {
      setFormData({
        nome: '',
        chavepix: '',
        valor: '',
        cidade: ''
      });
    }
  }, [pixKey]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async () => {
    try {
      if (pixKey && pixKey.id) {
        await api.put(`/bank_data/update-bkd-nome/${pixKey.id}`, { bkdnome: formData.nome });
        await api.put(`/bank_data/update-chavepix/${pixKey.id}`, { chavepix: formData.chavepix });
        await api.put(`/bank_data/update-valor/${pixKey.id}`, { valor: formData.valor });
        await api.put(`/bank_data/update-city/${pixKey.id}`, { cidade: formData.cidade });
      } else {
        await api.post('/bank_data/create-bank', formData);
      }

      onSave();
      onClose();
      Swal.fire('Sucesso!', 'Chave Pix salva com sucesso.', 'success');
      fetchData();
    } catch (error) {
      Swal.fire('Erro!', 'Falha ao salvar a Chave Pix.', 'error');
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 1, maxWidth: 400, margin: 'auto', mt: '10%' }}>
        <h2>{pixKey ? 'Editar Chave Pix' : 'Adicionar Chave Pix'}</h2>
        <TextField
          name="nome"
          label="Nome"
          value={formData.nome}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="chavepix"
          label="Chave Pix"
          value={formData.chavepix}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="valor"
          label="Valor"
          value={formData.valor}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <TextField
          name="cidade"
          label="Cidade"
          value={formData.cidade}
          onChange={handleChange}
          fullWidth
          margin="normal"
          required
        />
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
          <Button onClick={onClose} sx={{ mr: 2 }}>Cancelar</Button>
          <Button onClick={handleSubmit} variant="contained" color="primary">Salvar</Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PixKeyModal;
